module.exports = __webpack_public_path__ + "img/email-by-freepik.ac282788.png";